export default "__VITE_ASSET__BRYE3EHb__"